var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTotalSuper(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_913_31133)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6002 -0.8004C11.366 -0.8004 0.599609 10.1456 0.599609 23.5992C0.599609 37.0529 11.366 48 24.6002 48C37.8343 48 48.5996 37.054 48.5996 23.5992C48.5996 10.1444 37.8343 -0.8004 24.6002 -0.8004ZM24.6002 46.5789C12.1373 46.5789 1.99857 36.271 1.99857 23.5992C1.99857 10.9274 12.1373 0.621886 24.6002 0.621886C37.063 0.621886 47.2006 10.9297 47.2006 23.5992C47.2006 36.2687 37.0619 46.5789 24.6002 46.5789Z",
    fill: "#C17B16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6 -0.0898285C11.7504 -0.0898285 1.29834 10.5365 1.29834 23.5992C1.29834 36.662 11.7504 47.2894 24.6 47.2894C37.4496 47.2894 47.9005 36.662 47.9005 23.5992C47.9005 10.5365 37.4485 -0.0898285 24.6 -0.0898285Z",
    fill: "url(#paint0_linear_913_31133)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6 6.3777C27.8379 6.3777 30.5171 3.97695 31.0316 0.835729C28.9869 0.23784 26.8314 -0.0886993 24.6 -0.0886993C22.3687 -0.0886993 20.2132 0.23784 18.1685 0.835729C18.6819 3.9781 21.3622 6.3777 24.6 6.3777Z",
    fill: "url(#paint1_linear_913_31133)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6001 40.5068C21.2593 40.5068 18.5111 43.0616 18.1255 46.3523C20.1826 46.9583 22.3529 47.2894 24.6001 47.2894C26.8472 47.2894 29.0175 46.9583 31.0735 46.3523C30.6878 43.0616 27.9408 40.5068 24.6001 40.5068Z",
    fill: "url(#paint2_linear_913_31133)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65868 23.5992C7.65868 20.3085 5.29956 17.5835 2.20874 17.0604C1.62065 19.1392 1.29834 21.3307 1.29834 23.5992C1.29834 25.8677 1.62065 28.0592 2.20874 30.1381C5.29956 29.6149 7.65868 26.8911 7.65868 23.5992Z",
    fill: "url(#paint3_linear_913_31133)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5391 23.5992C41.5391 26.8911 43.8993 29.6149 46.9901 30.1381C47.5782 28.0592 47.9005 25.8677 47.9005 23.5992C47.9005 21.3307 47.5782 19.1392 46.9901 17.0604C43.8993 17.5847 41.5391 20.3085 41.5391 23.5992Z",
    fill: "url(#paint4_linear_913_31133)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.468 11.3758C38.7739 13.7202 42.3725 13.9364 44.9262 12.0393C42.7876 8.16677 39.6119 4.96347 35.7815 2.82372C33.9505 5.41648 34.1756 9.04521 36.468 11.3758Z",
    fill: "url(#paint5_linear_913_31133)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7307 35.5087C10.3863 33.1263 6.70626 32.9389 4.14697 34.9396C6.25615 38.8557 9.42389 42.1016 13.2543 44.2816C15.2595 41.6796 15.0887 37.906 12.7307 35.5099V35.5087Z",
    fill: "url(#paint6_linear_913_31133)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5092 11.3747C14.7744 9.07166 15.021 5.50042 13.2612 2.91455C9.46359 5.07385 6.31734 8.28176 4.20703 12.1519C6.74936 13.9272 10.2496 13.6708 12.508 11.3747H12.5092Z",
    fill: "url(#paint7_linear_913_31133)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4679 35.7329C34.1563 38.0819 33.9482 41.752 35.8278 44.3494C39.6583 42.1981 42.8316 38.9822 44.9623 35.0959C42.4064 33.17 38.7841 33.377 36.4679 35.7329Z",
    fill: "url(#paint8_linear_913_31133)"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6 1.58196C37.2257 1.58196 47.5296 11.8438 47.8835 24.5949C47.8892 24.3696 47.9005 24.1465 47.9005 23.92C47.9005 10.8561 37.4485 0.230957 24.6 0.230957C11.7515 0.230957 1.29834 10.8561 1.29834 23.92C1.29834 24.1465 1.30852 24.3707 1.3153 24.5949C1.66928 11.8438 11.9743 1.58196 24.6 1.58196Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.63
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6003 45.7959C11.9973 45.7959 1.70694 35.5697 1.3179 22.853C1.30998 23.1014 1.2998 23.3486 1.2998 23.5992C1.2998 36.662 11.7518 47.2894 24.6015 47.2894C37.4511 47.2894 47.902 36.662 47.902 23.5992C47.902 23.3486 47.8907 23.1014 47.8839 22.853C47.4937 35.5708 37.2045 45.7959 24.6015 45.7959H24.6003Z",
    fill: "#C17B16"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6001 7.38609C15.806 7.38609 8.65283 14.6619 8.65283 23.6004C8.65283 32.5388 15.8071 39.8147 24.6001 39.8147C33.393 39.8147 40.5473 32.54 40.5473 23.6004C40.5473 14.6608 33.3942 7.38609 24.6001 7.38609Z",
    fill: "url(#paint9_linear_913_31133)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6002 39.9112C15.9633 39.9112 8.90858 32.8941 8.65977 24.173C8.65525 24.3316 8.65186 24.4903 8.65186 24.649C8.65186 33.5897 15.8061 40.8633 24.5991 40.8633C33.3921 40.8633 40.5463 33.5886 40.5463 24.649C40.5463 24.4891 40.5429 24.3305 40.5384 24.173C40.2896 32.8941 33.2349 39.9112 24.5991 39.9112H24.6002Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1476 12.8384C22.1776 11.9737 23.2373 9.75121 22.7476 7.64365C21.3102 7.81496 19.8739 8.18635 18.4749 8.78309C17.076 9.37982 15.8082 10.1605 14.6807 11.0815C15.8161 12.9154 18.1176 13.7042 20.1476 12.8384Z",
    fill: "url(#paint10_linear_913_31133)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9747 34.2417C26.8791 35.135 25.8183 37.4714 26.4267 39.6388C27.8732 39.4686 29.3208 39.0961 30.7288 38.4959C32.1379 37.8957 33.4125 37.1069 34.5468 36.1779C33.4543 34.2175 31.0703 33.3494 28.9747 34.2428V34.2417Z",
    fill: "url(#paint11_linear_913_31133)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9771 28.1673C13.1266 26.1046 10.9428 25.025 8.86865 25.524C9.03716 26.9854 9.40245 28.4456 9.9894 29.8679C10.5764 31.2913 11.3454 32.5791 12.2513 33.7254C14.054 32.5699 14.8298 30.2324 13.9782 28.1673H13.9771Z",
    fill: "url(#paint12_linear_913_31133)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2254 19.1093C36.077 21.1743 38.2608 22.2517 40.3349 21.7538C40.1653 20.2924 39.8 18.8322 39.2142 17.4099C38.6272 15.9876 37.8582 14.6987 36.9512 13.5524C35.1485 14.7068 34.3727 17.0466 35.2243 19.1105L35.2254 19.1093Z",
    fill: "url(#paint13_linear_913_31133)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8827 12.8004C30.9353 13.6547 33.2481 12.828 34.3586 10.955C32.0153 9.09813 29.1959 7.93799 26.2408 7.62065C25.7624 9.73626 26.8425 11.9519 28.8827 12.8004Z",
    fill: "url(#paint14_linear_913_31133)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2382 34.2808C18.1517 33.4127 15.796 34.2808 14.708 36.2181C17.0434 38.1107 19.8696 39.2984 22.8349 39.6422C23.4184 37.4749 22.3361 35.1534 20.2382 34.2819V34.2808Z",
    fill: "url(#paint15_linear_913_31133)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8585 19.2047C14.683 17.1547 13.9151 14.8494 12.1418 13.6973C10.3187 16.0681 9.17534 18.9196 8.85303 21.9113C10.9068 22.3448 13.0352 21.2479 13.8585 19.2047Z",
    fill: "url(#paint16_linear_913_31133)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1831 28.0754C34.3417 30.1657 35.1594 32.5227 37.0096 33.6507C38.8553 31.2775 40.0133 28.4122 40.3447 25.4055C38.2434 24.8812 36.0268 25.9781 35.1831 28.0754Z",
    fill: "url(#paint17_linear_913_31133)"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6203 9.82707C17.1505 9.82707 11.0752 16.006 11.0752 23.5992C11.0752 31.1924 17.1517 37.3714 24.6203 37.3714C32.089 37.3714 38.1655 31.1936 38.1655 23.5992C38.1655 16.0049 32.089 9.82707 24.6203 9.82707Z",
    fill: "url(#paint18_linear_913_31133)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.63
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7234 37.3587C17.4334 37.3587 11.4711 31.473 11.1895 24.1304C11.1827 24.3109 11.1782 24.4914 11.1782 24.6743C11.1782 32.2686 17.2547 38.4464 24.7234 38.4464C32.192 38.4464 38.2685 32.2686 38.2685 24.6743C38.2685 24.4926 38.264 24.3109 38.2572 24.1304C37.9756 31.473 32.0133 37.3587 24.7234 37.3587Z",
    fill: "#C17B16"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6207 10.5399C31.9717 10.5399 37.969 16.5269 38.1579 23.9545C38.1601 23.8361 38.1669 23.7188 38.1669 23.5992C38.1669 16.006 32.0904 9.82707 24.6218 9.82707C17.1531 9.82707 11.0767 16.006 11.0767 23.5992C11.0767 23.7188 11.0823 23.8384 11.0857 23.958C11.2723 16.5292 17.2696 10.5411 24.6218 10.5411L24.6207 10.5399Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.63
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6001 8.36111C33.2324 8.36111 40.2793 15.3737 40.5348 24.0879C40.5394 23.9258 40.5473 23.7637 40.5473 23.6004C40.5473 14.6619 33.3942 7.38609 24.6001 7.38609C15.806 7.38609 8.65283 14.6619 8.65283 23.6004C8.65283 23.7637 8.65962 23.9258 8.66527 24.0879C8.91973 15.3737 15.9677 8.36111 24.6001 8.36111Z",
    fill: "#C17B16"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9878 29.678H18.1099L18.1088 29.677L17.9878 29.678Z",
    fill: "url(#paint19_linear_913_31133)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0044 29.678H31.1265L31.0055 29.677L31.0044 29.678Z",
    fill: "url(#paint20_linear_913_31133)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1833 32.5894H30.462L31.0546 30.3818H18.5918L19.1833 32.5894Z",
    fill: "url(#paint21_linear_913_31133)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1698 19.7072C35.1698 18.8851 34.5139 18.2182 33.7053 18.2182C32.8967 18.2182 32.2407 18.8851 32.2407 19.7072C32.2407 20.1372 32.4205 20.5235 32.7078 20.7949C32.5834 20.911 32.4499 21.0432 32.3029 21.1962C30.6337 22.9346 28.2757 25.7907 28.2757 25.7907C28.2757 25.7907 26.1688 22.2643 25.3341 21.0605C25.8397 20.8259 26.1914 20.3085 26.1914 19.706C26.1914 18.8839 25.5355 18.2171 24.7268 18.2171C23.9182 18.2171 23.2623 18.8839 23.2623 19.706C23.2623 20.3269 23.6355 20.8581 24.1659 21.0823C23.3211 22.3057 21.2391 25.7907 21.2391 25.7907C21.2391 25.7907 18.8799 22.9346 17.2118 21.1962C17.0535 21.0306 16.9087 20.8892 16.7764 20.7661C17.0456 20.4959 17.2118 20.1211 17.2118 19.7072C17.2118 18.8851 16.5559 18.2182 15.7473 18.2182C14.9387 18.2182 14.2827 18.8851 14.2827 19.7072C14.2827 20.5293 14.9081 21.1628 15.6907 21.1939L18.3111 29.5862H31.2082L33.8297 21.1904C34.5829 21.1283 35.1744 20.489 35.1744 19.7072H35.1698Z",
    fill: "url(#paint22_linear_913_31133)"
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5613 3.72745L12.1714 -3.20001L14.0103 3.32618L23.5304 0.754104L14.3111 3.77689L16.3174 13.0545L13.619 4.30465L3.94727 5.98678L13.5613 3.72745Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8325 3.44803L16.3534 -0.429047L14.225 3.47333L19.8253 6.77667L14.1582 3.82516L10.8503 9.08544L13.595 3.74238L8.33057 -0.0461676L13.8325 3.44803Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M16.226 2.0361C17.2551 3.22958 17.1397 5.04509 15.9658 6.09255C14.7931 7.14001 13.0062 7.02158 11.9771 5.8281C10.9468 4.63462 11.0633 2.81911 12.236 1.7728C13.4099 0.725346 15.1957 0.843774 16.226 2.0361Z",
    fill: "url(#paint23_radial_913_31133)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_913_31133",
    x1: 24.9969,
    y1: 2.02923,
    x2: 24.1787,
    y2: 44.9158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7ED43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F7C843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#F1BC3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E7AA30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#E19F2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E09C28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_913_31133",
    x1: 18.1685,
    y1: 3.1445,
    x2: 31.0316,
    y2: 3.1445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_913_31133",
    x1: 18.1255,
    y1: 43.8975,
    x2: 31.0735,
    y2: 43.8975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_913_31133",
    x1: 1.29834,
    y1: 23.5992,
    x2: 7.65868,
    y2: 23.5992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_913_31133",
    x1: 41.5391,
    y1: 23.5992,
    x2: 47.9005,
    y2: 23.5992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_913_31133",
    x1: 34.5601,
    y1: 8.06904,
    x2: 44.9262,
    y2: 8.06904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_913_31133",
    x1: 4.14697,
    y1: 38.9247,
    x2: 14.6386,
    y2: 38.9247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_913_31133",
    x1: 4.20816,
    y1: 8.11389,
    x2: 14.4182,
    y2: 8.11389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_913_31133",
    x1: 34.56,
    y1: 39.0707,
    x2: 44.9623,
    y2: 39.0707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_913_31133",
    x1: 24.6001,
    y1: 6.74796,
    x2: 24.6001,
    y2: 46.0707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E07828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBB43A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_913_31133",
    x1: 14.6807,
    y1: 10.4169,
    x2: 22.8663,
    y2: 10.4169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_913_31133",
    x1: 26.256,
    y1: 36.7643,
    x2: 34.5468,
    y2: 36.7643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_913_31133",
    x1: 8.86752,
    y1: 29.5643,
    x2: 14.3231,
    y2: 29.5643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_913_31133",
    x1: 34.8793,
    y1: 17.7135,
    x2: 40.3349,
    y2: 17.7135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_913_31133",
    x1: 26.1289,
    y1: 10.379,
    x2: 34.3586,
    y2: 10.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_913_31133",
    x1: 14.708,
    y1: 36.793,
    x2: 22.9932,
    y2: 36.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_913_31133",
    x1: 8.85303,
    y1: 17.8514,
    x2: 14.1899,
    y2: 17.8514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_913_31133",
    x1: 34.8518,
    y1: 29.4631,
    x2: 40.3447,
    y2: 29.4631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_913_31133",
    x1: 24.6203,
    y1: 6.74794,
    x2: 24.6203,
    y2: 46.0706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#E07828"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBB43A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_913_31133",
    x1: 17.9878,
    y1: 29.677,
    x2: 18.1099,
    y2: 29.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7ED43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F7C843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#F1BC3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E7AA30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#E19F2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E09C28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_913_31133",
    x1: 31.0044,
    y1: 29.677,
    x2: 31.1265,
    y2: 29.677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7ED43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#F7C843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#F1BC3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#E7AA30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#E19F2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E09C28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_913_31133",
    x1: 18.5918,
    y1: 31.4856,
    x2: 31.0546,
    y2: 31.4856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_913_31133",
    x1: 14.2782,
    y1: 23.9016,
    x2: 35.1698,
    y2: 23.9016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_913_31133",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.0998 3.93045) rotate(-41.7503) scale(2.84794 2.85366)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_913_31133"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.599609,
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTotalSuper);
export default __webpack_public_path__ + "static/media/icon-total-super.c1d351ad8bc95ec26bda55e91dec2465.svg";
export { ForwardRef as ReactComponent };